import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-svg-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent {
  @Input() idSuffix = '';
}
